module.exports = " <ul :class=\"{ 'tab-list': true, 'is-flex': true, [`is-${alignment}`]: alignment }\" role=tablist> <slot></slot> </ul> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-tabs/src/TabList.vue
// module id = 933
// module chunks = 2